var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 5.5V3.5C5 2.94922 5.44922 2.5 6 2.5H7V0H5C3.34375 0 2 1.34375 2 3V5.5H0V8H2V16H5V8H7L8 5.5H5Z","fill":"white"}));
}

FacebookInline.defaultProps = {"width":"8","height":"16","viewBox":"0 0 8 16","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
